import { UtilsBuilder } from "./utils-builder";
import { ProjectData } from "../entities/project-data.entity";
import { ProjectDataPresupuesto } from "../entities/project-data-presupuesto-entity";
import { ProjectDataPerimetro } from "../entities/project-data-perimetro.entity";
import { ConfigService } from "../app.config";
import { Datas3d } from "./scheme3d/datas3d";
import { CoorMaps } from "./scheme3d/coor-maps";
import { DB } from "../datas/db";
import { ComputeSatelite3d } from "./satelite3d/compute-satelite3d";
import { DatasSatelite } from "./satelite3d/datas-satelite";

export class BudgetSatelite {
	// Modelos de Verjas.
	// panelLength must match 'length' of each family defined at app/builder/scheme3d/panels3d.ts
	public readonly Verjas = {
		"BRICO-FAX": { idElemento: "interm_50", panelLength: 2.53 },
		FAX: { idElemento: "interm_50", panelLength: 2.53 },
		"FAX DH": { idElemento: "interm_50", panelLength: 2.53 },
		"MAXI-FAX": { idElemento: "interm_80", panelLength: 2.64 },
		RITMO: { idElemento: "interm", panelLength: 2.53 },
		"RITMO DH": { idElemento: "interm", panelLength: 2.53 },
		RITMOCLIP: { idElemento: "interm", panelLength: 2.504 },
		CLASSIC: { idElemento: "interm", panelLength: 2.835 },
		NATURE: { idElemento: "interm", panelLength: 2.57 },
		NATURE_CUADRADO: { idElemento: "interm", panelLength: 2.545 },
		CALITAX: { idElemento: "interm", panelLength: 2.835 },
		CALITAX_CUADRADO: { idElemento: "interm", panelLength: 2.815 },
		NOVE: { idElemento: "interm", panelLength: 2.565 },
		NOVE_CUADRADO: { idElemento: "interm", panelLength: 2.55 },
		ULTRA: { idElemento: "interm", panelLength: 2.835 },
		ULTRA_CUADRADO: { idElemento: "interm", panelLength: 2.815 },
		DECOR: { idElemento: "interm", panelLength: 2.835 },
		DECOR_CUADRADO: { idElemento: "interm", panelLength: 2.815 },
	};

	// Mensajes que se retornan como resultado de la creación del presupuesto.
	public readonly MessageError = {
		OK: { message: "Budget: Ok." },
		Undefined: { message: "Budget: Projecto undfined." },
		Empty: { message: "Budget: Projecto sin perímetros." },
		LengthExceeded: {
			message: "Budget: Longitud del perímetro superior al permitido.",
		},
		NeedIdUser: { message: "Budget: Falta el identidicador del usuario." },
		UnknownFamily: { message: "La familia no tiene tipo." },
		ServerError: { message: "Retorno del servidor con error." },
		DontMakeIt: {
			message:
				"No se ha podido crear el pedido para que lo ejecute el servidor.",
		},
	};

	private _statusBudget = 0; // 0 = ok, 1 = problemas conexión.
	private _proccessEnd = true; // Indica si el gestor termino.
	public get proccessEnd() {
		return this._proccessEnd;
	}

	// Proyecto a procesar.
	private projectData: ProjectData;
	public datasSatelite: DatasSatelite;

	private tiempoMaximoEspera = 0;

	// Utilidades para calculos de perímetros.
	private utilsBuilder: UtilsBuilder;

	// Resultado que se retorna.
	// error        : Retorna código del error o 0 si todo fue bien.
	public result = {
		error: this.MessageError.OK,
		lengthExceeded: false,
	};

	// Stores length of the posts
	private calculatedPostsSizes = [];
	// Stores the quantity of double posts on the perimeter
	private quantityDoublePosts = 0;

	// #########################################################################
	// #########################################################################
	// Constructor.
	public constructor(projectData: ProjectData) {
		this.projectData = projectData;
	}

	// Reinicia los valores del objeto de retorno.
	private _clearResult() {
		this.result.error = this.MessageError.OK;
		this.result.lengthExceeded = false;
	}

	// Recibe los angulos y points.
	public createBudget(obj3d = false): boolean {
		// Reiniciar objeto de retorno.
		this._clearResult();

		// Si no hay projecto rechazar.
		if (!this.projectData) {
			this.result.error = this.MessageError.Undefined;
			return false;
		}

		// Debe tener un identifcador de usuario.
		if (!this.projectData.userId || this.projectData.userId == "") {
			this.result.error = this.MessageError.NeedIdUser;
			return false;
		}

		// Obtener la suma de todas las longitudes de todos los perímetros.
		// Si no hay perímetros definidos rechazar.
		if (
			!this.projectData.perimetro ||
			this.projectData.perimetro.length == 0
		) {
			this.result.error = this.MessageError.Empty;
			return false;
		}

		this.utilsBuilder = new UtilsBuilder();

		// Divisor de tramos, particiona los tramos de los perímetros en secciones.
		this.datasSatelite = new DatasSatelite(false);
		// Crear las divisiones del perímetro, si obj3d = true carga los modelos 3D.
		this.datasSatelite.insertNo3D(this.projectData, true /*obj3d*/);
		this._proccessEnd = false;
		// Esperar a que se ejectuten los procesos de datasSatelite.
		this.tiempoMaximoEspera = 0;
		this.waitProccess();
	}

	private async waitProccess() {
		if (this.tiempoMaximoEspera > 22000) {
			console.warn(
				"Tiempo de espera en BudgetSatelite sobrepasado: " +
					this.tiempoMaximoEspera
			);
			this._proccessEnd = true;
			return;
		}

		if (this.datasSatelite.ProccessEnd && this.datasSatelite.loadFinish) {
			// Finalizado.

			if (this.datasSatelite.status === 1) {
				// Avisar que se tuvo problemas con la conexión.
				console.warn(
					"Presupuesto, tiempo excedido, repitalo en otra ocasión."
				);
			} else {
				// Comprobar si el perímetro es más largo de lo permitido.
				// Se sigue adelante con el presupuesto pero se le avisa.
				let perimeterTotalLength = 0;
				for (let perimeter of this.projectData.perimetro) {
					perimeterTotalLength += perimeter.longitud;
				}
				this.result.lengthExceeded =
					perimeterTotalLength >
					ConfigService.MAX_PERIMETER_LENGTH_METERS;

				// Si es true todo fue bien y se pide el presupuesto.
				let allRight = false;

				for (
					let index = 0;
					index < this.projectData.perimetro.length;
					index++
				) {
					let perimetro = this.projectData.perimetro[index];
					// Crear un presupuesto limpio.
					perimetro.presupuesto = new ProjectDataPresupuesto();

					this.utilsBuilder.iniciar(perimetro.coordenadas);
				}

				//Check if all data is ready
				let computeSat = new ComputeSatelite3d(
					this.projectData,
					this.datasSatelite
				);
				await computeSat.initGestorSatelite();
				computeSat.computeGeometry();
				this.calculatedPostsSizes = computeSat.calculatePoleSizes();
				// ESPRRIVISA-128 : get the quantity of double poles
				this.quantityDoublePosts = computeSat.countDoublePost();

				for (
					let index = 0;
					index < this.projectData.perimetro.length;
					index++
				) {
					let perimetro = this.projectData.perimetro[index];
					// Actualiza perímetro cerrado, arrays ang1 y ang2.
					//perimetro.longitud ML = perimetro.longitud;
					//perimetro.presupuesto.unity.m l = perimetro.longitud;
					// Bifurcar según Familia.
					if (perimetro.producto.familia.tipo === DB.CERCADO) {
						allRight = this.__CERCADOS(
							perimetro,
							this.datasSatelite.datas[index]
						);
					} else if (perimetro.producto.familia.tipo === DB.VERJA) {
						console.log("Project Data", this.projectData);
						allRight = this.__VERJAS(
							perimetro,
							this.datasSatelite.datas[index]
						);
					} else {
						console.error(this.MessageError.UnknownFamily.message);
					}
				}

				//this.projectData.perimetro.forEach(perimetro => {});
				// Enviar al servidor.
				if (!allRight) {
					// No se ha podido crear el pedido para que lo ejecute el servidor.
					this.result.error = this.MessageError.DontMakeIt;
				}
			}

			this._proccessEnd = true; //allRight;
		} else {
			setTimeout(() => {
				this.tiempoMaximoEspera += 300;
				this.waitProccess();
			}, 300);
		}
	}

	// ##################################################################### CERCADOS SATÉLITE
	public __CERCADOS(
		perimetro: ProjectDataPerimetro,
		datas3d: Datas3d
	): boolean {
		let _producto = perimetro.producto;
		let _tipoPanel = perimetro.producto.tipoPanel;
		let _panel = perimetro.producto.panel;
		//let _informacion = perimetro.informacion;
		let _presupuesto = perimetro.presupuesto;

		let rects = 0; // Tramo recto. CON PIES (LUX)
		let interms = 0; // Total de postes internos del perímtero. (LUX)
		let interms_des = 0; // Total de postes internos del perímtero. (LUX)
		let rects_des = 0; // postes normales.
		let extremoIzq = 0; // poste límite izquierdo.
		let extremoIzq_des = 0; // poste límite izquierdo.
		let extremoDer = 0; // poste límite derecho.
		let extremoDer_des = 0; // poste límite derecho.
		let anguloInter = 0; // Angulo con la malla por dentro.
		let anguloInter_des = 0; // Angulo con la malla por dentro.
		let angulo = 0; // Angulo cona la malla por fuera.
		let angulo_des = 0; // Angulo cona la malla por fuera.

		//'LUX_ANUDADA': { 'extr.i_50', 'extr.d_50', 't.ang_50', 't.int_50', 'interm_50', 't.rect_50' } // 100, 150, 200
		// if (perimetro.producto.tipoPanel.modeloStr !== this.CERCADO_ANUDADA) POR DEFECTO.
		let interm = "interm_50";
		let extr_i = "extr.i_50";
		let extr_d = "extr.d_50";
		let t_ang = "t.ang_50";
		let t_int = "t.int_50";
		let t_rect = "t.rect_50";

		//'LUX_ELECTRO': { 'extr.i_50', 'extr.d_50', 't.ang_50', 't.int_50', 'interm_50', 't.rect_50' }, // 100x50 -> 100
		//'LUX_ELECTRO': { 'extr.i_80', 'extr.d_80', 't.ang_80', 't.int_80', 'interm_50', 't.rect_80' }, // 100x50 -> 150 | 50x50 -> 150 200
		//'LUX_ELECTRO': { 'extr.i_80', 'extr.d_80', 't.ang_80', 't.int_80', 'interm_80', 't.rect_80' }, // 100x50 -> 200 |
		if (_tipoPanel.modeloStr === DB.CERCADO_ELECTRO) {
			if (_panel.alturaValor > 1000) {
				if (
					_panel.alturaValor === 2000 &&
					_panel.medidaMalla === "100x50"
				)
					interm = "interm_80";
				extr_i = "extr.i_80";
				extr_d = "extr.d_80";
				t_ang = "t.ang_80";
				t_int = "t.int_80";
				t_rect = "t.rect_80";
			}
		}
		//1 15 2(50) anchuraPoste
		//'LUX_EXT': { 'extr.i_50', 'extr.d_50', 't.ang_50', 't.int_50', 'interm_50', 't.rect_50' },
		//2(80) 3 4
		//'LUX_EXT': { 'extr.i_80', 'extr.d_80', 't.ang_80', 't.int_80',  'interm_80',  't.rect_80' },
		else if (_tipoPanel.modeloStr === DB.CERCADO_LUX_EXT) {
			if (
				(_panel.alturaValor === 2000 &&
					_producto.anchuraPoste &&
					_producto.anchuraPoste === "LUX80") ||
				_panel.alturaValor > 2000
			) {
				interm = "interm_80";
				extr_i = "extr.i_80";
				extr_d = "extr.d_80";
				t_ang = "t.ang_80";
				t_int = "t.int_80";
				t_rect = "t.rect_80";
			}
		}

		for (
			let index = CoorMaps.Data;
			index < perimetro.post.length;
			index += CoorMaps.Offset
		) {
			let p = perimetro.post[index];
			// Indica si se tiene que tomar el poste superior del mismo tipo.
			let _des = (p & 0x80) !== 0;
			if ((p & 0x40) !== 0) {
				// Ignorar angulo, poner poste normal.
				// Tiene que ser de una medida superior.
				if (_des) {
					interms_des++;
				} else {
					interms++;
				}
			} else if ((p & 0x04) !== 0) {
				// Poste estremo Derecho.
				if (_des) {
					extremoIzq_des++;
				} else {
					extremoIzq++;
				}
			} else if ((p & 0x02) !== 0) {
				// Poste estremo Izquierdo.
				if (_des) {
					extremoDer_des++;
				} else {
					extremoDer++;
				}
			} else if ((p & 0x08) !== 0) {
				// Poste angulo.
				if (_des) {
					angulo_des++;
				} else {
					angulo++;
				}
			} else if ((p & 0x10) !== 0) {
				// Poste angulo interno.
				if (_des) {
					anguloInter_des++;
				} else {
					anguloInter++;
				}
			} else if ((p & 0x01) !== 0) {
				// Poste con tornapuntas.
				if (_des) {
					rects_des++;
				} else {
					rects++;
				}
			} else {
				// Poste normal.
				if (_des) {
					interms_des++;
				} else {
					interms++;
				}
			}
		}

		// Angulos Externos.
		if (angulo > 0)
			_presupuesto.unity.elementos.push({
				idElemento: t_ang,
				altura: _panel.altura,
				cantidad: angulo,
			});
		// Angulos Externos des.
		if (angulo_des > 0)
			_presupuesto.unity.elementos.push({
				idElemento: t_ang + "_des",
				altura: _panel.altura,
				cantidad: angulo_des,
			});
		// Angulos Internos.
		if (anguloInter > 0)
			_presupuesto.unity.elementos.push({
				idElemento: t_int,
				altura: _panel.altura,
				cantidad: anguloInter,
			});
		// Angulos Internos des.
		if (anguloInter_des > 0)
			_presupuesto.unity.elementos.push({
				idElemento: t_int + "_des",
				altura: _panel.altura,
				cantidad: anguloInter_des,
			});
		// Postes intermedios.
		if (interms > 0)
			_presupuesto.unity.elementos.push({
				idElemento: interm,
				altura: _panel.altura,
				cantidad: interms,
			});
		// Postes intermedios des.
		if (interms_des > 0)
			_presupuesto.unity.elementos.push({
				idElemento: interm + "_des",
				altura: _panel.altura,
				cantidad: interms_des,
			});
		// Postes con tornapuntas.
		if (rects > 0)
			_presupuesto.unity.elementos.push({
				idElemento: t_rect,
				altura: _panel.altura,
				cantidad: rects,
			});
		// Postes con tornapuntas altos.
		if (rects_des > 0)
			_presupuesto.unity.elementos.push({
				idElemento: t_rect + "_des",
				altura: _panel.altura,
				cantidad: rects_des,
			});
		// Extermo izquierdo con tornapuntas.
		if (extremoIzq > 0)
			_presupuesto.unity.elementos.push({
				idElemento: extr_i,
				altura: _panel.altura,
				cantidad: extremoIzq,
			});
		// Extermo izquierdo con tornapuntas des.
		if (extremoIzq_des > 0)
			_presupuesto.unity.elementos.push({
				idElemento: extr_i,
				altura: _panel.altura,
				cantidad: extremoIzq_des,
			});
		// Extermo derecho con tornapuntas.
		if (extremoDer)
			_presupuesto.unity.elementos.push({
				idElemento: extr_d,
				altura: _panel.altura,
				cantidad: extremoDer,
			});
		// Extermo derecho con tornapuntas des.
		if (extremoDer_des)
			_presupuesto.unity.elementos.push({
				idElemento: extr_d,
				altura: _panel.altura,
				cantidad: extremoDer_des,
			});

		_presupuesto.unity.ml = perimetro.longitudML;
		//_presupuesto.unity.ml = perimetro.longitud;
		_presupuesto.unity.mlStr = perimetro.longitudML.toString();

		if (_producto.tipoBayoneta !== "no") {
			_presupuesto.unity.cantidadBayonetas = angulo + anguloInter;
			_presupuesto.unity.cantidadBayonetas +=
				interms + rects + rects_des + extremoIzq + extremoDer;
		}

		console.log("panel alturaValor", perimetro.producto.panel.alturaValor);
		console.log("rects", rects);
		console.log("rects_des", rects_des);
		console.log("interms", interms);
		console.log("interms_des", interms_des);
		console.log("extremoIzq", extremoIzq);
		console.log("extremoIzq_des", extremoIzq_des);
		console.log("extremoDer", extremoDer);
		console.log("extremoDer_des", extremoDer_des);
		console.log("quantityDoublePosts", this.quantityDoublePosts);
		console.log("calculatedPostsSizes", this.calculatedPostsSizes);

		return false;
	}

	// Array de números que contienen los postes. Se debe leer de cuatro en cuatro.
	// la cuarta 'd' es una dato con valores binarios (flags).
	// 0000 0000 0x00 [  0] => El poste por defecto, ej.: 1m00.
	// 1000 0000 0x80 [128] => Poste siguientes, ej.: 1m50, cuando hay diferencia de alturas.
	// 0000 0001 0x01 [  1] => Poste recto con tornapuntas.
	// 1000 0001 0x81 [129] => Poste recto con tornapuntas, siguiente poste.
	// 0000 0010 0x02 [  2] => Poste extremo Izquierdo.
	// 1000 0010 0x82 [130]=> Poste extremo Izquierdo, siguiente poste.
	// 0000 0100 0x04 [  4] => Poste extremo Derecho.
	// 1000 0100 0x84 [132]=> Poste extremo Derecho, siguiente poste.
	// 0000 1000 0x08 [  8] => Poste angulo (tornapuntas) externo, tiene la malla por el angulo grande.
	// 1000 1000 0x88 [136] => Poste angulo (tornapuntas) externo, tiene la malla por el angulo grande, poste siguiente.
	// 0001 0000 0x10 [ 16] => Poste angulo (tornapuntas) interno, tiene la malla por el angulo agudo.
	// 1001 0000 0x90 [144] => Poste angulo (tornapuntas) interno, tiene la malla por el angulo agudo, poste siguiente.
	// Rellena en el proyecto el array post [x,y,z,d,...] y el parametro revisarAlturas, por perímetro.
	// ESPECIALES::
	//	1000 0000 0x80 [128] => Añadir para indicar que es con desnivel (_des) poste con la altura soguiente.
	//	0100 0000 0x40 [ 64] => Añadir para indicar que el angulo no debe tener torna puntas (40º a 140º si tiene tornapuntas).

	// ##################################################################### VERJAS SATÉLITE
	public __VERJAS(
		perimetro: ProjectDataPerimetro,
		datas3d: Datas3d
	): boolean {
		// 1 15 2 'BRICO-FAX': { 'interm_50' }
		// 06 1 12 15 18 2 'FAX': { 'interm_50' }
		// 1 12 14 16 18 2 'FAX DH': { 'interm_50' }
		// 15 2 24 'MAXI-FAX' { 'interm_50' }
		// 06 08 1 12 15 18 2 24 'RITMO' { 'interm' }
		// 1 12 14 16 18 2 'RITMO DH' { 'interm' }
		// 06 1 12 15 18 2 'RITMOCLIP' { 'interm' }
		// 06 1 15 2 'CLASSIC' { 'interm' } "cantidadComodines":4,
		// 1 15 2 'CALITAX' { 'interm' }
		// 06 1 15 'NOVE' { 'interm' } "cantidadComodines":4,
		// 1 15 2 'ULTRA' { 'interm' }
		// 06 1 15 2 'DECOR' { 'interm' }
		// 1 12 15 18  2 24 'NATURE' { 'interm' }
		// No se pueden permitir perímetros de un solo punto.
		if (perimetro.coordenadas.length < 2) return false;

		//let _producto = perimetro.producto;
		let _tipoPanel = perimetro.producto.tipoPanel;
		let _panel = perimetro.producto.panel;
		let _informacion = perimetro.informacion;
		let tieneMuro = _informacion.tieneMuro;
		let _presupuesto = perimetro.presupuesto;

		// Obtener la verja.
		let bIsSquare = perimetro.producto.tipoPoste.indexOf("Cuadrado") != -1;
		let completePanelString = _tipoPanel.modeloStr;
		if (bIsSquare) {
			completePanelString += "_CUADRADO";
		}

		let verja = this.Verjas[completePanelString];
		if (!verja) return false;

		// Calcular los postes.
		let cantidadPostes = 0;
		let cantidadPostes_des = 0;
		let cantidadPostes_dob = 0;
		let cantidadPostes_dob_des = 0;

		//let bRecuento:boolean = false;

		if (perimetro.coordenadas.length <= 1) {
			return;
		}

		// ESPRRIVISA-127 - ESPRRIVISA-137
		// Pole height threshold
		const poleHeightThreshold = 0.1;

		// console.log("datas3d", datas3d);
		// console.log("perimetro", perimetro);

		// let lastSeccion: any;

		//perimetro.longitudML = a la suma de todas las distancias de un punto a otro.
		_presupuesto.unity.ml = perimetro.longitudML;
		//_presupuesto.unity.ml = perimetro.longitud;

		//_presupuesto.unity.cantidadBayonetas = cantidadPostes + cantidadPostes_des;
		_presupuesto.unity.cantidadBayonetas = cantidadPostes;
		_presupuesto.unity.cerrado = datas3d.closed;

		// ESPRRIVISA-127 With CLASSIC and NOVE we need need to create the field 'cantidadComodines', which will contain the number
		// of accessories needed. 1 accessory for each shortened panel.
		if (
			_tipoPanel.modeloStr === "CLASSIC" ||
			_tipoPanel.modeloStr === "NOVE"
		) {
			_presupuesto.unity.cantidadComodines = 0;
			let panelLength = datas3d.separation; // Length of the panel model.
			let tramos = datas3d.coors; // Array containing info about tramos.

			// Loop through tramos.
			for (
				let indexTramo = 0;
				indexTramo < tramos.length - 1;
				indexTramo++
			) {
				// Loop through sections of each tramo.
				for (
					let indexSection = 0;
					indexSection < tramos[indexTramo].sections.length;
					indexSection++
				) {
					let section = tramos[indexTramo].sections[indexSection]; // Array containing info about a section.
					let sectionLength = section.magnitud; // Length without unevenness of the section.

					if (section.door === "" && section.magnitud > 0.09) {
						// If the section is not a door and the section is > 0.09 - to not count when the section is a double post

						// Calculate how much length we have left for the last panel.
						let rest = sectionLength % panelLength;

						// If there is remaining length, means that there is gonna be atleast one shortened panel,
						// so we add 1 accessory.
						if (rest != 0) {
							_presupuesto.unity.cantidadComodines += 1;
						}

						// If the remaining length its less that 30% of the length of a panel we need to add another accessory,
						// because the remainings will be distributed between the first panel and de last one.
						if (rest < panelLength * 0.3) {
							_presupuesto.unity.cantidadComodines += 1;
							//console.log("After checking the 30%: ", _presupuesto.unity.cantidadComodines);
						}
					}
				}
			}

			//console.log("Total accessories CLASSIC / NOVE", _presupuesto.unity.cantidadComodines);
		}

		// // First check if the current perimeter has DoublePoles assigned
		// for (let index = 0; index < datas3d.coors.length - 1; index++){
		// 	// calcular datas 3d coors, para contar los postes dobles y mirar de erestarlos al total
		// 	if(datas3d.coors[index].posteAdicional.x !== undefined){
		// 		cantidadPostes_dob++;
		// 	}
		// }

		let bHasDoublePoles = cantidadPostes_dob > 0;

		// Estimate the size of all registered poles
		// for (let index = CoorMaps.Data; index < perimetro.post.length/* - CoorMaps.Offset*/; index += CoorMaps.Offset) {
		// 	let p = perimetro.post[index];
		// 	console.log("p: " + p);

		// 	if(p >= 128){
		// 		if( p === 132 && bHasDoublePoles ) {
		// 			cantidadPostesDobles++;
		// 		} else {
		// 			cantidadPostes_des++;
		// 		}

		// 	}else{
		// 		if( p === 4) {
		// 			if( index > 0 && bHasDoublePoles) {
		// 				cantidadPostesDobles++;
		// 			} else {
		// 				cantidadPostes++;
		// 			}
		// 		} else {
		// 			cantidadPostes++;
		// 		}
		// 	}
		// }

		// If perimeter is closed, use Google Maps data to estimate Pole height
		// If perimeter is open, both start and end will be normal poles if there is a wall. If not, use GoogleMaps info.
		// let cerrado = datas3d.closed;
		// if (!cerrado && tieneMuro) {
		// 	cantidadPostes += 1;
		// 	if( cantidadPostes_des > 0 ) {
		// 		cantidadPostes_des -= 1
		// 	}
		// };

		// cantidadPostes = 0;
		// cantidadPostes_des = 0;

		// Calculate pole height including poleHeightThreshold
		// alturaValor in mm
		function calculatePoleHeightWithThreshold() {
			const poleHeightWithThreshold =
				perimetro.producto.panel.alturaValor / 1000 +
				poleHeightThreshold;
			return poleHeightWithThreshold;
		}

		for (let index = 0; index < this.calculatedPostsSizes.length; index++) {
			this.calculatedPostsSizes[index].distance >
			calculatePoleHeightWithThreshold()
				? (cantidadPostes_des += 1)
				: (cantidadPostes += 1);
		}

		if (cantidadPostes > 0) {
			_presupuesto.unity.elementos.push({
				idElemento: verja.idElemento,
				altura: _panel.altura,
				cantidad: cantidadPostes,
				esPosteAdicional: false,
			});
		}

		if (cantidadPostes_des > 0) {
			_presupuesto.unity.elementos.push({
				idElemento: verja.idElemento + "_des",
				altura: _panel.altura,
				cantidad: cantidadPostes_des,
				esPosteAdicional: false,
			});
		}

		// ESPRRIVISA-128: sent data in unity.elementos
		if (this.quantityDoublePosts > 0) {
			_presupuesto.unity.elementos.push({
				quantity: this.quantityDoublePosts,
				esPosteAdicional: true,
			});
		}

		/*if (cantidadPostes_dob_des > 0) {
			_presupuesto.unity.elementos.push({
				"idElemento": verja.idElemento,
				"altura": _panel.altura,
				"cantidad": cantidadPostes_dob_des,
				"esPosteAdicional": true
			});
			// console.log("presupuesto con desnivel", _presupuesto.unity.elementos);
		}*/

		// console.log("_panel", _panel);
		console.log("panel alturaValor", perimetro.producto.panel.alturaValor);
		console.log("cantidadPostes", cantidadPostes);
		console.log("cantidadPostes_des", cantidadPostes_des);
		console.log("quantityDoublePosts", this.quantityDoublePosts);
		console.log("calculatedPostsSizes", this.calculatedPostsSizes);
		console.log("poleHeightThreshold", poleHeightThreshold);

		return true;
	}
}
